import Project from '../models/Project';
import ENUM from './Enums';

const ProjectsData = () => [
    new Project(1,
      	"PANATTONI PARK OŻARÓW II",
        "PANNATONI EUROPE",
        [ENUM.Filters.LOGISTICS],
    ),
    new Project(2,
        "PANATTONI PARK OŻARÓW II",
        "TRANSGOURMET SELGROS",
        [ENUM.Filters.BTS],
    ),
    new Project(3,
   	"SILESIA LOGISTICS CENTER",
        "MENARD DOSWELL & CO.",
        [ENUM.Filters.BTS],
    ),
    new Project(4,
        "HILLWOOD PHN PARK WROCŁAW IV",
        "HILLWOOD POLSKA",
        [ENUM.Filters.LOGISTICS],
    ),
    new Project(5,
      	"HILLWOOD PHN PARK KOŁBASKOWO",
        "HILLWOOD POLSKA",
        [ENUM.Filters.LOGISTICS],
    ),
    new Project(6,
      	"GERDA SOKOŁÓW",
        "GERDA SP. Z O.O.",
        [ENUM.Filters.LOGISTICS],
    ),
    new Project(7,
        "EXETER PARK SZCZECIN II",
        "EQT EXETER",
        [ENUM.Filters.LOGISTICS],
    ),
    new Project(8,
        "EL-BOX KONOTOPA",
        "EL-BOX Sp. z o.o.",
        [ENUM.Filters.PRIVATE],
    ),
    new Project(9,
        "ART EXPO KAJETANY",
        "ART EXPO Sp.J.",
        [ENUM.Filters.PRIVATE],
    ),
    new Project(10,
        "ZALANDO LONGUE AMERYKA",
        "HILLWOOD POLSKA",
        [ENUM.Filters.BTS],
    ),
    new Project(11,
        "DL INVEST PARK PSARY",
        "DL PROJECT MANAGEMENT S.A.",
        [ENUM.Filters.RECENT, ENUM.Filters.LOGISTICS],
    ), new Project(12,
   	"PARZNIEW LOGISTIC CENTER",
        "HILLWOOD POLSKA",
        [ENUM.Filters.BTS, ENUM.Filters.LOGISTICS], 
    ), new Project(13,
        "MPM LOGISTICS CENTER",
        "PROJEKT NOVA S.A.",
        [ENUM.Filters.PRIVATE],
    ), new Project(14,
        "EXETER PARK SZCZECIN",
        "EXETER PROPERTY GROUP",
        [ENUM.Filters.RECENT, ENUM.Filters.LOGISTICS],
    ), new Project(15,
        "HILLWOOD PARK OLSZTYNEK",
        "HILLWOOD POLSKA",
        [ENUM.Filters.LOGISTICS],
    ), new Project(16,
      	"HILLWOOD PARK ŚWIEBODZIN",
        "HILLWOOD POLSKA",
        [ENUM.Filters.LOGISTICS],
    ),  new Project(17,
     	"BIOELEKTRA MSZCZONÓW",
        "BIOELEKTRA DEVELOPMENT SP. Z.O.O.",
        [ENUM.Filters.PRIVATE],
    ),  new Project(18,
 	"HILLWOOD PARK MYSŁOWICE",
        "HILLWOOD POLSKA",
        [ENUM.Filters.LOGISTICS],
    ), new Project(19,
      	"HILLWOOD PARK BYDGOSZCZ",
        "HILLWOOD POLSKA",
        [ENUM.Filters.RECENT, ENUM.Filters.LOGISTICS],
    ), new Project(20,
     	"PARK WAN KUTNO",
        "WAN S.A.",
        [ENUM.Filters.RECENT, ENUM.Filters.LOGISTICS],
    ), new Project(21,
        "WAIMEA LOGISTIC PARK BYDGOSZCZ",
        "WAIMEA HOLDING S.A.",
        [ENUM.Filters.LOGISTICS],
    ), new Project(22,
        "DĘBICA HUTCHINSON",
        "DL INVEST GROUP S.A.",
        [ENUM.Filters.BTS],
    ), new Project(23,
      	"HILLWOOD PARK OLEŚNICA",
        "HILLWOOD POLSKA",
        [ENUM.Filters.LOGISTICS],
    ), new Project(24,
        "HILLWOOD PARK KUTNO",
        "HILLWOOD POLSKA",
        [ENUM.Filters.LOGISTICS],
    ), new Project(25,
        "HILLWOOD PARK GLIWICE WSCHÓD",
        "HILLWOOD POLSKA",
        [ENUM.Filters.LOGISTICS],
    ), new Project(26,
        "HILLWOOD PARK GLIWICE ZACHÓD",
        "HILLWOOD POLSKA",
        [ENUM.Filters.LOGISTICS],
    ), new Project(27,
        "EL-BOX KONOTOPA EKSPANSJA",
        "EL-BOX SP. Z O.O.",
        [ENUM.Filters.PRIVATE],
    ), new Project(28,
        "INDUSTRIAL PARK POLAND KONIN",
        "HILLWOOD POLSKA",
        [ENUM.Filters.LOGISTICS],
    ), new Project(29,
        "CH KARUZELA",
        "KARUZELA HOLDING SP. Z O.O.",
        [ENUM.Filters.PRIVATE],
    ), new Project(30,
      	"APM PARK WYPĘDY 1",
        "APM DEVELOPMENT",
        [ENUM.Filters.BTS],
    ), new Project(31,
       	"BIOODPADY OŻARÓW",
        "BIOODPADY.PL SP Z O.O.",
        [ENUM.Filters.PRIVATE],
    ), new Project(32,
      	"PANATTONI PARK KONOTOPA III",
        "HARDEN CONSTRUCTION",
        [ENUM.Filters.LOGISTICS],
    ), new Project(33,
        "HIPARK PIASECZNO",
        "HINES POLSKA SP. Z O.O.",
        [ENUM.Filters.LOGISTICS],
    ), new Project(34,
    	"AMAZON DISTRIBUTION CENTER",
        "HILLWOOD POLSKA",
        [ENUM.Filters.BTS],
    ), new Project(35,
        "HILLWOOD PARK KŁOBUCK",
        "HILLWOOD POLSKA",
        [ENUM.Filters.BTS],
    ), new Project(36,
        "BYDGOSZCZ PRZYŁĘKI ZALANDO",
        "HILLWOOD POLSKA",
        [ENUM.Filters.BTS],
    ), new Project(37,
        "WHITE STAR LOGISTICS PARK KONIK",
        "WHITE STAR LOGISTICS",
        [ENUM.Filters.LOGISTICS],
    ), new Project(38,
        "PRODREX BIERUŃ",
        "PRODREX-POLAND SP. Z O.O.",
        [ENUM.Filters.PRIVATE],
    ), new Project(39,
      	"PANATTONI PARK PSARY CARREFOUR",
        "HARDEN CONSTRUCTION",
        [ENUM.Filters.LOGISTICS],
    ), new Project(40,
        "PANATTONI PARK POZNAŃ XII",
        "HARDEN CONSTRUCTION",
        [ENUM.Filters.LOGISTICS],
    ), new Project(41,
        "HILLWOOD PARK ZGIERZ A",
        "HILLWOOD POLSKA",
        [ENUM.Filters.LOGISTICS],
    ), new Project(42,
        "HILLWOOD PARK ZGIERZ B",
        "HILLWOOD POLSKA",
        [ENUM.Filters.LOGISTICS]
    ), new Project(43,
        "HILLWOOD PARK JANOWICE",
        "HILLWOOD POLSKA",
        [ENUM.Filters.LOGISTICS],
    ), new Project(44,
     	"HILLWOOD PARK GRODZISK MAZOWIECKI",
        "HILLWOOD POLSKA",
        [ENUM.Filters.LOGISTICS],
    ), new Project(45,
     	"PARZNIEW LOGISTICS CENTER",
        "POLSKI HOLDING NIERUCHOMOŚCI S.A",
        [ENUM.Filters.LOGISTICS]
    ), new Project(46,
        "BIOELEKTRA WIERZBICA",
        "BIOELEKTRA WIERZBICA SP. Z O.O.",
        [ENUM.Filters.PRIVATE],
    ), new Project(47,
        "HILLWOOD PARK ZGORZELEC",
        "HILLWOOD POLSKA",
        [ENUM.Filters.LOGISTICS],
    ), new Project(48,
       	"HILLWOOD PARK ŁAZY",
        "HILLWOOD POLSKA",
        [ENUM.Filters.LOGISTICS],
    ), new Project(49,
        "SALON AGATA MEBLE",
        "AGATA S.A.",
        [ENUM.Filters.PRIVATE],
    ), new Project(50,
       	"CH KARUZELA EŁK",
        "KARUZELA HOLDING SP. Z O.O.",
        [ENUM.Filters.PRIVATE],
    ), new Project(51,
        "CH KARUZELA BIAŁA PODLASKA",
        "KARUZELA HOLDING SP. Z O.O.",
        [ENUM.Filters.PRIVATE],
    ), new Project(52,
        "CTP PARK KONIK",
        "CTPARK KONIK SP. Z O.O",
        [ENUM.Filters.LOGISTICS],
    ), new Project(53,
        "APM BUSINESS PARK ZAMIENIE",
        "APM DEVELOPMENT SP. Z O.O.",
        [ENUM.Filters.LOGISTICS],
    ), new Project(54,
        "APM BUSINESS PARK ZGORZAŁA",
        "APM DEVELOPMENT SP. Z O.O.",
        [ENUM.Filters.PRIVATE],
    ), new Project(55,
        "MPM LOGISTICS CENTER EKSPANSJA",
        "PROJEKT NOVA S.A.",
        [ENUM.Filters.PRIVATE],
    ), new Project(56,
        "WARSAW PARK STRAŻACKA",
        "ROBUST ESTATE SP. Z O.O.",
        [ENUM.Filters.LOGISTICS],
    ), new Project(57,
        "ZAKŁAD PRODUKCYJNY ENTALPIA",
        "ENTALPIA EUROPE SP. Z O.O.",
        [ENUM.Filters.LOGISTICS],
    ), new Project(58,
        "P3 PARK MSZCZONÓW",
        "P3 MSZCZONÓW PARK SP. Z O.O.",
        [ENUM.Filters.LOGISTICS],
    ),
];

export default ProjectsData;